package fyi.moko.hotpl.ui.photo

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

/** One line in a [PhotoActionSheet]. */
data class PhotoAction(val label: String, val onClick: () -> Unit)

/**
 * 사진 타일을 탭했을 때 올라오는 시트. 화면마다 항목은 다르지만 **모양과 뜻은 하나여야
 * 한다** — 편집 화면에서는 탭이 곧 삭제, 상세에서는 탭이 메뉴였던 것이 리뷰어가 사진을
 * 반복해서 잃은 이유였다(2026-09-08 피드백 R-6). 그래서 시트 본문을 여기 한 곳에 둔다.
 *
 * 파괴적인 항목은 목록 맨 아래다. 오탭이 비싼 쪽이 위에 있으면 안 된다.
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PhotoActionSheet(actions: List<PhotoAction>, onDismiss: () -> Unit) {
    ModalBottomSheet(onDismissRequest = onDismiss) {
        Column(Modifier.fillMaxWidth().padding(bottom = 24.dp)) {
            actions.forEach { action ->
                Text(
                    text = action.label,
                    style = MaterialTheme.typography.bodyLarge,
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable(onClick = action.onClick)
                        .padding(horizontal = 24.dp, vertical = 16.dp),
                )
            }
        }
    }
}
